import React from 'react'
import Star from '../images/Star.svg';

export default function TechnologyCube({image, name, nStars})
{
    return (
        <div className="tec-cube">
            <img 
                src={image} 
                className="tec-cube"
                alt={name}
            />
            <p>{name}</p>
            <div>
                {[...Array(nStars).keys()].map((star) =>
                    <img 
                        key = {name + "star" + star}
                        src={Star} 
                        className="tec-star"
                        alt={name}
                    />
                )}
            </div>
        </div>  
    )
}